import React, { useRef } from "react";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";

const VideoIdButtons: React.FC<{ rowData: any }> = ({ rowData }) => {
  const toast = useRef<Toast>(null);

  const url = `https://www.youtube.com/watch?v=${rowData.videoId}`;

  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      <Button
        icon="pi pi-copy"
        className="p-button-secondary p-button-rounded"
        tooltip="Copy URL"
        tooltipOptions={{ position: "top" }}
        style={{ marginRight: "0.5rem" }}
        size="small"
        onClick={() => {
          navigator.clipboard.writeText(url);
          toast.current?.show({
            severity: "info",
            summary: "Copied to Clipboard",
            detail: url,
            life: 1000,
          });
        }}
      />

      <Button
        icon="pi pi-external-link"
        className="p-button-rounded"
        size="small"
        tooltip="Open in new tab"
        tooltipOptions={{ position: "top" }}
        onClick={() => window.open(url, "_blank")}
      />
      <Toast ref={toast} />
    </div>
  );
};

export default VideoIdButtons;
